<button (click)="submitTask()"
  [dsBtnDisabled]="processing$ | async"
  class="declineTaskAction btn btn-warning"
  ngbTooltip="{{'submission.workflow.tasks.claimed.decline_help' | translate}}"
  type="button">
  @if (processing$ | async) {
    <span>
      <i class='fas fa-circle-notch fa-spin'></i> {{'submission.workflow.tasks.generic.processing' | translate}}
    </span>
  }
  @if ((processing$ | async) !== true) {
    <span>
      <i class="fa fa-ban"></i> {{'submission.workflow.tasks.claimed.decline' | translate}}
    </span>
  }
</button>
